<div class="container">
    <app-list entityName="Accessory" module="MovimientoBienes"
              [url]="PAGES.MOVEMENT_ACCESSORIES">
    </app-list>
</div>
